import React from 'react';
import Navbar from '../../components/landingPageComponent/Navbar';
import OurProducts from '../../components/landingPageComponent/OurProducts';
import ScrollTop from '../../components/landingPageComponent/ScrollTop';
import Footer from '../../components/landingPageComponent/Footer';

const Products = () => {
	return (
		<>
			<Navbar />
			<OurProducts />
			<Footer />
			<ScrollTop />
		</>
	);
};

export default Products;
